module.exports = __webpack_public_path__ + "static/mountain-field-5291d5b45eb2debeb119f943c949bc47.jpg";